<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="4" height="12" rx="1" fill="black"/>
<rect x="8.98682" y="4.33337" width="4" height="7.33331" rx="1" fill="black"/>
<path d="M1.3335 8H14.6668" stroke="black" stroke-linecap="round"/>
</svg>
